import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';

import {
  getFolders,
  getFoldersFailure,
  getFoldersSuccess,
  getFiles,
  getFilesFailure,
  getFilesSuccess,
  getFilesList,
  getFilesListFailure,
  getFilesListSuccess,
} from './support-center.actions';
import { SupportCenterService } from '@intellio/shared/services';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class SupportCenterEffects {
  getFolders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getFolders),
      mergeMap(() =>
        this.supportCenterService.getFolders().pipe(
          map((resp) => getFoldersSuccess({ folders: resp.data })),
          catchError((error: any) => of(getFoldersFailure({ error })))
        )
      )
    )
  );

  getFiles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getFiles),
      mergeMap(({ path }) =>
        this.supportCenterService.getFiles(path).pipe(
          map((resp) => getFilesSuccess({ path, files: resp.data })),
          catchError((error: any) => of(getFilesFailure({ error })))
        )
      )
    )
  );

  getFilesList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getFilesList),
      mergeMap(({ path }) =>
        this.supportCenterService.getFilesList(path).pipe(
          map((resp) => getFilesListSuccess({ path, filesList: resp.data })),
          catchError((error: any) => of(getFilesListFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private supportCenterService: SupportCenterService
  ) {}
}
